/**
 * RBAC scope model (reskin-docs/03 §1). A permission is NOT boolean — it carries one of five
 * scopes. IDs are the seeded `permission_types` rows (1 added · 2 owned · 3 both · 4 all · 5 none).
 */
export const SCOPE = { ADDED: 1, OWNED: 2, BOTH: 3, ALL: 4, NONE: 5 } as const;
export type ScopeId = (typeof SCOPE)[keyof typeof SCOPE];
export type ScopeName = "added" | "owned" | "both" | "all" | "none";

export const SCOPE_NAME: Record<ScopeId, ScopeName> = {
  1: "added",
  2: "owned",
  3: "both",
  4: "all",
  5: "none",
};

/**
 * Effective scope across a user's roles + overrides = the MOST PERMISSIVE that applies
 * (reskin-docs/03 §2: ALL > BOTH > {ADDED,OWNED} > NONE). Special case: holding ADDED from one
 * source and OWNED from another resolves to BOTH (can see either).
 */
export function combineScopes(scopes: ScopeId[]): ScopeId {
  let hasAdded = false,
    hasOwned = false,
    hasBoth = false;
  for (const s of scopes) {
    if (s === SCOPE.ALL) return SCOPE.ALL;
    if (s === SCOPE.BOTH) hasBoth = true;
    else if (s === SCOPE.ADDED) hasAdded = true;
    else if (s === SCOPE.OWNED) hasOwned = true;
  }
  if (hasBoth || (hasAdded && hasOwned)) return SCOPE.BOTH;
  if (hasAdded) return SCOPE.ADDED;
  if (hasOwned) return SCOPE.OWNED;
  return SCOPE.NONE;
}
